import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FamilyBar from "../../../components/cases/familyTree/FamilyBar";
import FamilyChart from "../../../components/cases/familyTree/FamilyChart";
import { getFtOnBoardingList } from "../../../redux/slices/features/ftOnBoardingSlice";
import "../yourAssets.scss";

const AdvisorFamilyTree = () => {
  const [showDetails, setShowDetails] = useState(false);
  const mainText = useSelector(
    (state) => state.ftOnBoarding.fTSuggestionBoxText
  );

  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      dispatch(getFtOnBoardingList());
    })();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={5}
        sx={{
          marginTop: "0.5rem",
        }}
        className="family-tree-grid "
      >
        <Grid item lg={9} md={12} sm={12} xs={12} className="left-side">
          <FamilyChart />
        </Grid>
        <Grid item lg={3} md={12} sm={12} xs={12} className="right-side">
          <FamilyBar />
        </Grid>
      </Grid>
      {/* <SuggestionBox
        mainText={mainText[0]}
        tabName="AdvisorFamilyTree"
        next={showDetails}
        setVisited={visited}
        click={() => {
          setShowDetails(!showDetails);
        }}
      /> */}
    </>
  );
};

export default AdvisorFamilyTree;
